

























import { mapGetters } from 'vuex';
import { DateRangeParams } from '@/api/schema';
import { MIN_DATE } from '@/helpers/copyStakeHelpers';
import { getMonthPeriodDates } from '@/helpers/getPeriodDates';
import { DateTime } from 'luxon';
import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';

const CopyStakeDashboardGraphs = (): Promise<any> =>
  import(
    /* webpackMode: "lazy" */ '@/views/CopyStake/CopyStakeDashboard/CopyStakeDashboardGraphs.vue'
  );
const CopyStakeDashboardStats = (): Promise<any> =>
  import(
    /* webpackMode: "lazy" */ '@/views/CopyStake/CopyStakeDashboard/CopyStakeDashboardStats.vue'
  );
const VExtendedDataPicker = (): Promise<any> =>
  import(/* webpackMode: "lazy" */ '@/components/VExtendedDataPicker.vue');

type TCopyStakeDashboardState = {
  MIN_DATE: string;
  dates: DateRangeParams;
};

export default {
  name: 'CopyStakeDashboardView',
  mixins: [FeatureFlagRedirectMixin],
  components: {
    CopyStakeDashboardStats,
    CopyStakeDashboardGraphs,
    VExtendedDataPicker
  },
  data(): TCopyStakeDashboardState {
    return {
      MIN_DATE,
      dates: { ...getMonthPeriodDates(false) }
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    datesForBackend(): DateRangeParams {
      // COP-1666
      return {
        ...this.dates,
        to: DateTime.fromISO(this.dates.to)
          .plus({ day: 1 })
          .toFormat('yyyy-LL-dd')
      };
    }
  }
};
